<template>
  <b-modal centered ref="modal-new" v-model="showModalNewConversation" title="Nova Conversa">
    <b-tabs @input="onTabChange">
      <b-tab title="Não Associado">
        <b-form-group label="Nome" label-for="conversation-person">
          <b-form-input id="conversation-person" v-model="newConversationPerson"></b-form-input>
        </b-form-group>
        <b-form-group label="Telefone" label-for="conversation-subject">
          <b-form-input id="conversation-subject" v-model="newConversationSubject"
            v-mask="phoneMask" required></b-form-input>
        </b-form-group>
      </b-tab>

      <b-tab title="Associado" ref="associado">
        <form>
          <b-form-group label="Associado" label-for="conversation-associate">
            <v-select ref="selectAssociate" v-model="newConversationAssociate" :options="associates"
              :reduce="x => x.value" class="w-100" label="text" placeholder="Digite o Nome e Sobrenome"
              @search="debouncedGetAssociates" @input="handleAssociateChange" filterable>
              <template v-slot:no-options>Nenhum associado encontrado.</template>
            </v-select>
          </b-form-group>
          <b-form-group label="Número" label-for="conversation-number">
            <v-select ref="selectNumber" v-model="newConversationNumber" :options="numbers" class="w-100"
              label="text" placeholder="Selecione o número" clearable>
              <template v-slot:no-options>Nenhum número encontrado.</template>
            </v-select>
          </b-form-group>
        </form>
      </b-tab>
    </b-tabs>

    <div v-if="hasProviders">
      <b-form-group label="Selecione um Provedor" label-for="cmb-provider">
        <b-form-select id="mode-select" class="w-100" v-model="typeOption" required>
          <b-form-select-option v-for="option in types" :key="option.id" :value="option.name">
            {{ option.name }}
          </b-form-select-option>
        </b-form-select>
        <div class="invalid-feedback">
          Por favor, forneça um número válido.
        </div>
      </b-form-group>
      <b-form-group label="Número para envio do Ativo" label-for="conversation-send">
        <div>
          <p class="text-align">{{ numberProvider }}</p>
        </div>
      </b-form-group>
      <b-form-group label="Parâmetro do HSM" label-for="conversation-hsm" v-if="typeProvider === 'WHATS_META'">
        <b-form-select id="conversation-hsm" @change="updateHsmText" v-model="selectedHsm" required>
          <b-form-select-option v-for="hsm in hsms" :key="hsm.id" :value="hsm.id">
            {{ hsm.hsmName }}
          </b-form-select-option>
        </b-form-select>
      </b-form-group>

      <div v-if="typeProvider === 'WHATS_META'">
        <b-form-group v-for="(param, index) in templateParameters" :key="index" :label="'Parâmetro ' + param.name">
          <b-form-input v-model="param.text" @input="updateMessage" required></b-form-input>
        </b-form-group>
      </div>
      <b-form-group label="Mensagem" label-for="conversation-subject">
        <b-form-textarea id="conversation-subject" v-model="newConversationMessage" :disabled="typeProvider === 'WHATS_META'" required></b-form-textarea>
      </b-form-group>
    </div>
    <div v-else>
      <p class="text-danger">Não existe provedor cadastrado para disparo de ativos</p>
    </div>

    <template #modal-footer>
      <div class="w-100 text-right">
        <button type="button" class="btn btn-third btn-sm" @click="createConversation" v-b-tooltip.hover
          :title="'Criar'" :disabled="!hasProviders"><i class="fas fa-check-circle"></i><span class="d-md-down-none"> Criar</span></button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import AssociateRepository from '@/shared/http/repositories/business/associate'
import NumRepository from '@/shared/http/repositories/access/cadastroNum'
import HsmRepository from '@/shared/http/repositories/configurations/hsm'
import AtendimentoRepository from '@/shared/http/repositories/atendimento/atendimento'
import AccountMixin from '@/store/module/account/mixin'
import { debounce } from 'lodash'

export default {
  name: 'NewConversationModal',
  data () {
    return {
      showModalNewConversation: false,
      newConversationPerson: '',
      newConversationSubject: '',
      newConversationMessage: '',
      newConversationAssociate: null,
      newConversationAssociateName: '',
      newConversationNumber: null,
      newAssociateConversationMessage: '',
      activeTabIndex: 0,
      associates: [],
      numbers: [],
      originalMessage: '',
      types: [],
      typeOption: '',
      typeProvider: '',
      identifierProvider: 1,
      hsms: [],
      templateParameters: [],
      variables: [],
      hsmId: '',
      selectedHsm: '',
      numberProvider: '',
      pessoa: null,
      associateName: '',
      size: 10
    }
  },
  mixins: [AccountMixin],
  computed: {
    hasProviders () {
      return this.types.length > 0
    },
    phoneMask () {
      // Detecta se é número 0800 baseado no valor atual
      if (this.newConversationSubject && this.newConversationSubject.startsWith('0800')) {
        return '#### ## ####'
      }
      // Para números normais
      return ['(##) ####-####', '(##) # ####-####']
    }
  },
  watch: {
    typeOption (newVal) {
      const selectedType = this.types.find(type => type.name === newVal)
      if (selectedType) {
        this.numberProvider = selectedType.formattedNumber
        this.identifierProvider = selectedType.number
        this.newConversationMessage = ''
        this.typeProvider = selectedType.type
      }
    },
    templateParameters: {
      handler: 'updateMessage',
      deep: true
    }
  },
  created () {
    this.getAssociates()
    this.loadNumbers()
    this.loadHms()
  },
  methods: {
    async createConversation () {
      if (!this.newConversationMessage.trim()) {
        this.$bvToast.toast('A mensagem não pode estar vazia!', {
          title: 'Erro',
          variant: 'danger',
          solid: true
        })
        return
      }

      if (this.typeProvider === 'WHATS_META') {
        const isMeta = await this.isMeta()
        this.$emit('createNewConversation', isMeta)
      } else if (this.typeProvider === 'WHATS_WPP') {
        const isWPP = await this.isWPP()
        this.$emit('createNewConversation', isWPP)
      }
    },
    async isWPP () {
      const identifier = this.activeTabIndex === 0 ? this.newConversationSubject : this.newConversationNumber.value
      const identifierFormat = identifier.replace(/\D/g, '')
      const requestConfig = {
        identifier: identifierFormat,
        operatorId: this.account.id,
        status: 'A',
        provider: this.typeProvider.toLowerCase(),
        type: 'chat',
        message: {
          type: 'text',
          text: this.newConversationMessage
        },
        name: this.activeTabIndex === 0 ? this.newConversationPerson : this.newConversationAssociateName,
        botId: 'NDA',
        identifierProvider: this.identifierProvider,
        activeStatus: true
      }
      try {
        this.clearFields()
        this.closeModal()
        const response = await AtendimentoRepository.CreateConversation(requestConfig)
        return await response.data
      } catch (error) {
        console.error(error)
      }
    },
    async isMeta () {
      const identifier = this.activeTabIndex === 0 ? this.newConversationSubject : this.newConversationNumber.value
      const identifierFormat = identifier.replace(/\D/g, '')
      const components = []
      if (this.selectedHsmObj.hasVideo) {
        const component = {
          type: 'header',
          parameters: [
            {
              type: 'video',
              video: {
                id: this.selectedHsmObj.hsmVideoId
              }
            }
          ]
        }
        components.push(component)
      } else if (this.selectedHsmObj.hasImage) {
        const component = {
          type: 'header',
          parameters: [
            {
              type: 'image',
              image: {
                id: this.selectedHsmObj.hsmImageId
              }
            }
          ]
        }
        components.push(component)
      }
      components.push({
        type: 'body',
        parameters: this.templateParameters.map(param => ({
          name: param.name,
          type: param.type,
          text: param.text
        }))
      })

      const requestConfig = {
        identifier: identifierFormat,
        operatorId: this.account.id,
        status: 'A',
        provider: this.typeProvider.toLowerCase(),
        type: 'template',
        message: {
          type: 'template',
          template: {
            name: this.hsmId,
            components
          }
        },
        name: this.activeTabIndex === 0 ? this.newConversationPerson : this.newConversationAssociateName,
        botId: 'NDA',
        identifierProvider: this.identifierProvider
      }
      try {
        this.clearFields()
        this.closeModal()
        const response = await AtendimentoRepository.CreateConversation(requestConfig)
        return await response.data
      } catch (error) {
        console.error(error)
      }
    },
    openModal () {
      this.clearFields()
      this.showModalNewConversation = true
    },
    handleAssociateChange () {
      if (this.newConversationAssociate === null) {
        this.newConversationNumber = null
        this.numbers = []
        return
      }
      this.newConversationNumber = ''
      this.getAssociateNumbers()
    },
    closeModal () {
      this.showModalNewConversation = false
    },
    clearFields () {
      this.newConversationPerson = ''
      this.newConversationSubject = ''
      this.newConversationMessage = ''
      this.newConversationAssociate = null
      this.newConversationAssociateName = ''
      this.newConversationNumber = null
      this.originalMessage = ''
      this.typeOption = ''
      this.typeProvider = ''
      this.selectedHsm = ''
      this.numberProvider = ''
    },
    onTabChange (index) {
      this.activeTabIndex = index
      this.clearFields()
    },
    async getAssociateNumbers () {
      this.numbers = []
      const id = this.newConversationAssociate
      const response = await AssociateRepository.GetById(id)
      let p = response.data
      if (p.pessoa) {
        this.pessoa = p.pessoa
        p.pessoa.telefone.forEach(phone => {
          if (phone.telefone != null && phone.tipoContato === 'CELULAR') {
            this.numbers.push({ value: phone.telefone, text: phone.telefone })
          }
        })
        this.newConversationAssociateName = p.pessoa.nome
      }
    },
    async getAssociates () {
      if (this.associateName.trim() === '') return
      this.associates = []
      const response = await AssociateRepository.GetByNomeAssociado(this.associateName, this.size)
      let associados = response.data.content
      this.associates = associados.map(res => ({
        value: res.id,
        text: res.pessoa.nome
      }))
    },
    async GetByNomeAssociado (nome) {
      const response = await AssociateRepository.GetByNomeAssociado(nome)
      let associados = response.data.content
      this.associates = associados.map(res => ({
        value: res.pessoa.id,
        text: res.pessoa.nome
      }))
    },
    updateHsmText () {
      const selectedHsmObj = this.hsms.find(hsm => hsm.id === this.selectedHsm)
      if (selectedHsmObj) {
        this.selectedHsmObj = selectedHsmObj
        this.newConversationMessage = selectedHsmObj.hsmText
        this.originalMessage = selectedHsmObj.hsmText
        this.variables = selectedHsmObj.variaveisHsmList
        this.templateParameters = this.variables.map(variable => ({
          name: variable,
          type: 'text',
          text: this.getValueParameters(variable)
        }))
        this.hsmId = selectedHsmObj.hsmId
      }
    },
    updateMessage () {
      let message = this.originalMessage
      this.templateParameters.forEach(param => {
        let regex = new RegExp(`@${param.name}@`, 'gi')
        message = message.replace(regex, param.text)
        if (param.name.toLowerCase() === 'celular') {
          regex = new RegExp('@Telefone@', 'gi')
          message = message.replace(regex, param.text)
        }
      })
      this.newConversationMessage = message
    },
    replacePlaceholders (message) {
      return message
        .replace(/@Nome@/gi, this.newConversationPerson)
        .replace(/@Telefone@/gi, this.newConversationSubject)
        .replace(/@Email@/gi, (this.pessoa && this.pessoa.email) || '')
    },
    getValueParameters (parametro) {
      if (parametro.toLowerCase() === 'nome') {
        if (this.activeTabIndex === 0) {
          return this.newConversationPerson
        } else {
          return this.newConversationAssociateName
        }
      } else if (parametro.toLowerCase() === 'celular') {
        if (this.activeTabIndex === 0) {
          return this.newConversationSubject
        } else {
          return this.newConversationNumber.value
        }
      } else if (parametro.toLowerCase() === 'email') {
        return (this.pessoa && this.pessoa.email) || ''
      }
      return ''
    },
    capitalizeFirstLetter (string) {
      return string.charAt(0).toUpperCase() + string.slice(1)
    },
    async loadHms () {
      try {
        const response = await HsmRepository.GetAll()
        this.hsms = response.data.content
      } catch (error) {
        console.error('Erro ao carregar HSMs:', error)
      }
    },
    async loadNumbers () {
      try {
        const requestConfig = {
          params: {
            active: 1
          }
        }
        const response = await NumRepository.getEnvAll(requestConfig)
        this.types = response.data.content
      } catch (error) {
        console.error('Erro ao carregar números:', error)
      }
    },
    debouncedGetAssociates: debounce(function (search) {
      this.associateName = search
      this.getAssociates()
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/atendimento/components/modal/NewConversationModal.vue